import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import CtaLink from '@stories/Components/Buttons/CtaLink/CtaLink';
import Modal from '@stories/Components/Misc/Modal/Modal';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './PeopleCard.styles';
const PeopleCard = (props) => {
    const [modalOpen, setModalOpen] = React.useState(false);
    const srcs = getSrcs(props.image, 730, 375, 5, 428 / 278);
    const sizes = `${until(Device.Tablet)} 100vw, ${until(Device.TabletLarge)} 50vw, ${until(Device.DesktopSmall)} 33vw, ${until(Device.DesktopLarge)} 25vw, 428px`;
    return (React.createElement(React.Fragment, null,
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.Container, { onClick: () => setModalOpen(true) },
                props.tag && React.createElement(S.HighlightedTag, null, props.tag),
                React.createElement(S.ImageWrapper, null,
                    React.createElement(S.Img, { src: srcs[0].split(' ')[0], srcSet: srcs.join(','), sizes: sizes, alt: props.image.altText ?? props.name, loading: 'lazy' })),
                React.createElement(S.ContentWrapper, null,
                    React.createElement(S.Name, null, props.name),
                    React.createElement(S.Role, null, props.role),
                    React.createElement(CtaLink, { as: "span" }, props.ctaText)))),
        React.createElement(Modal, { showClose: true, ariaLabel: `${props.name} Biography Modal`, isOpen: modalOpen, showBackground: true, onClose: () => {
                setModalOpen(false);
            }, closeOnBackground: true },
            React.createElement(S.BioWrapper, null,
                React.createElement(S.ImageWrapper, null,
                    React.createElement(S.Img, { src: srcs[0].split(' ')[0], srcSet: srcs.join(','), sizes: `${until(Device.TabletLarge)} 100vw, ${until(Device.DesktopLarge)} 35vw, 428px`, alt: props.image.altText ?? props.name, loading: 'lazy' })),
                React.createElement("div", null,
                    React.createElement(S.BioTitle, null, props.name),
                    React.createElement(S.Role, null, props.role),
                    React.createElement(S.Biography, null, props.biography))))));
};
export default PeopleCard;
